// For SEO purposes, we need to ensure our main navigation links end in a trailing slash.
export var ensureTrailingSlash = function ensureTrailingSlash() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (url.endsWith('.pdf')) {
    return url;
  }
  return url.endsWith('/') || url.includes('?') || url.includes('#') ? url : "".concat(url, "/");
};